import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { ZohoCopySource } from 'app/model/pipeline/copysource/zoho.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(ZohoCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class ZohoCopySourceAdapter extends CopySourceAdapter<ZohoCopySource, Model.ZohoSource> {
    protected override async _toResource(copySource: ZohoCopySource): Promise<Model.ZohoSource> {
        return this._toTabularResource(copySource, Metamodel.modelFor(ZohoCopySource).name);
    }

    protected override async _toModel(resource: Model.ZohoSource, copyActivity: CopyActivity): Promise<ZohoCopySource> {
        return this._toTabularModel(resource, copyActivity, ZohoCopySource.MODEL);
    }
}
